<template>
  <div class="main">
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" class="demo-split-pane" style="height: 100%">
        <my-tree style="height:calc(100% - 140px)" ref="fleetTree" modal="video" @car="reCarNo"
          filterGroup="车辆"></my-tree>
        <div id="vselect">
          <ly-form-item label="开始时间">
            <DatePicker type="datetime" placement="bottom-end" v-model="startTime" style="width: 100%"
              :clearable="false"></DatePicker>
          </ly-form-item>
          <ly-form-item label="结束时间">
            <DatePicker type="datetime" placement="bottom-end" v-model="endTime" style="width: 100%" :clearable="false">
            </DatePicker>
          </ly-form-item>
          <div style="margin-top: 10px;">
            <Button @click="chaxun" type="primary" long>立即查询</Button>
          </div>

        </div>
      </div>
      <div slot="right" class="demo-split-pane" style="height:100%">

        <historyVideoTool ref="historyVideoTool"></historyVideoTool>
      </div>
    </Split>
  </div>
</template>
<script>
import myTree from "../locate/locateToolCarPerson.vue";
import historyVideoTool from "./historyVideoTool.vue";

export default {
  components: { myTree, historyVideoTool },
  data() {
    return {
      split: "260",
      startTime: new Date(Date.now() - 3600 * 1000 * 4),
      endTime: new Date(),
      //startTime: new Date(2024,5,11,14,30),
      //endTime: new Date(2024,5,11,17,40),
      searchItem: {
        carNo: '',
        deviceNo: '',
        deviceModel: '',
        deviceProtocol: '',

      }
    };
  },
  methods: {
    reCarNo(v) {
      this.searchItem = {
        carNo: v.carNo,
        deviceNo: v.deviceNo,
        deviceModel: v.deviceModel,
        deviceProtocol: v.deviceProtocol,
      };
    },
    chaxun() {
      this.deviceNo;
      if (
        this.searchItem.deviceNo.length == 0
      ) {
        this.$Message.error("车牌号或时间段必须填写完整");
        return;
      }

      let params = {
        ...this.searchItem,
        startTime: this.startTime.getTime(), //开始时间（时间戳，精确至秒）
        endTime: this.endTime.getTime(), //结束时间（时间戳，精确至秒）
      };
      this.$refs.historyVideoTool.reach(params);
    },
  },
  mounted() { }

};
</script>
<style>
#vselect {
  width: 100%;
  height: 140px;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/video/byCarVideoHistory.vue